// extracted by mini-css-extract-plugin
export default {"container":"k1-z","heading":"l1-z","links":"m1-z","copy":"n1-z","subCopy":"o1-z","linksLeft":"p1-z","linksCenter":"q1-z","linksRight":"r1-z","link":"s1-z","onlyLink":"t1-z"};